<div class="flight-arrow" [ngClass]="INDRA_printArrowStyles()">
	<div class="arrow_flight__line"></div>
	<div class="arrow_flight__head">
		<svg preserveAspectRatio="xMinYMid meet" width="10px" height="16px" viewBox="0 0 10 16" stroke="none" stroke-width="1"
		 fill="none" fill-rule="evenodd">
			<polygon points="0 1.85840113 1.41729205 0.441109083 8.97618296 8 1.41729205 15.5588909 0 14.1415989 5.13942205 9.00217682 5.13942205 6.99782318"></polygon>
		</svg>
	</div>
	<div *ngIf="INDRA_hasAllStops()" class="arrow_flight__stops">
		<div *ngFor="let stop of allStops; let index = index" >
			<div class="arrow_flight__stop"  [tooltip]="getLocation(stop)"></div>
		</div>
	</div>
</div>


